/**
 * Schritt 1 "Inhalt" (33a) — Titel/Beschreibung/Button-Label/interner Name. Beschriftungen und
 * Hilfetexte WORTGLEICH aus dem alten Drawer in widgets-tab.tsx uebernommen (Zeilen ~633-672,
 * ~692-705 vor dem Umbau) — der E2E-Test (apps/e2e/tests/widget-editor.spec.ts) sucht die Felder
 * ueber genau diese Labels (`getByLabel("Titel")`, `getByLabel("Beschreibung")`).
 */
import { Button, Card, Icon, Input, Textarea } from "../../../ui/components";
import type { WidgetEditor } from "../useWidgetEditorForm";

export default function ContentStep({ editor, onNext }: { editor: WidgetEditor; onNext: () => void }) {
  const { form, widget } = editor;
  if (!widget) return null;

  return (
    <Card className="space-y-4 p-4">
      <label className="block">
        <span className="mb-1 block font-body-sm text-body-sm font-semibold text-on-surface dark:text-inverse-on-surface">Name *</span>
        <Input
          required
          maxLength={200}
          placeholder="z. B. Catering-Anfrage"
          value={form.name}
          onChange={(e) => editor.updateForm((f) => ({ ...f, name: e.target.value }))}
        />
        <span className="mt-1 block font-label-md text-label-md text-on-surface-variant">
          Interner Name — erscheint in der Anfragen-Herkunft, nicht auf Ihrer Website.
        </span>
      </label>

      <label className="block">
        <span className="mb-1 block font-body-sm text-body-sm font-semibold text-on-surface dark:text-inverse-on-surface">Titel</span>
        <Input
          maxLength={200}
          placeholder="z. B. Jetzt Catering anfragen"
          value={form.title}
          onChange={(e) => editor.updateForm((f) => ({ ...f, title: e.target.value }))}
        />
      </label>

      <div>
        <label className="block">
          <span className="mb-1 block font-body-sm text-body-sm font-semibold text-on-surface dark:text-inverse-on-surface">Beschreibung</span>
          <Textarea
            rows={3}
            maxLength={1000}
            placeholder="Kurzer Text unter dem Titel (optional)."
            value={form.description}
            onChange={(e) => editor.updateForm((f) => ({ ...f, description: e.target.value }))}
          />
        </label>
        <span className="mt-1 block font-label-md text-label-md text-on-surface-variant">
          Titel und Beschreibung stehen über dem Formular auf Ihrer Website.
        </span>
      </div>

      {widget.kind === "form" && (
        <label className="block">
          <span className="mb-1 block font-body-sm text-body-sm font-semibold text-on-surface dark:text-inverse-on-surface">
            Beschriftung des Absende-Knopfes
          </span>
          <Input
            maxLength={60}
            placeholder="Anfrage senden"
            value={form.submitLabel}
            onChange={(e) => editor.updateForm((f) => ({ ...f, submitLabel: e.target.value }))}
          />
        </label>
      )}

      <div className="flex justify-end pt-2">
        <Button type="button" onClick={onNext}>
          Weiter <Icon name="arrow_forward" className="text-[16px]" />
        </Button>
      </div>
    </Card>
  );
}
